<div id="wrap"  class="practiceList-bgblue" *ngIf='practiceList'>
  <div class="common-back-btn-sight" id="closeBtn"  (click)="close();" *ngIf="isOpenClass==0 && type!== 'huatek' && !isTencent">
    <span>×</span>
  </div>

  <div id="head_wrap" class="fontSize18">
    情景模拟
  </div>

  <!-- 提醒 -->
  <app-com-tip *ngIf="isShowToast" [type]="'toast'" [desText]="promptText" [cancelText]="''" [sureText]="''" ></app-com-tip>

<div *ngIf="practiceList">
    <div class="practiceList-listeImgItem" [ngStyle]="{'background-image': practice.extends ? practice.extends.bg : '' }" *ngFor="let practice of practiceList;let i = index" (click)="goToNextStep()">
			<div class="practiceList-listeImgItemHead-Img">

				<img *ngIf="practice.extends && practice.extends.userPhoto != ''" src="{{practice.extends.userPhoto}}" class="practiceList-icon"  />
				<div *ngIf="practice.status" class="practice-status">
					已完成
				</div>
			</div>
			<div class="practiceList-listeImgItemHead fontSize16">
				{{practice.title}}
			</div>
			<div class="practiceList-listeImgItemContent fontSize14 lineHeight21">
				{{practice.description}}
				<div class="entryBtn">进入</div>
			</div>
		</div>

    <div class="approachModuleWrap" [ngClass]="type === 'huatek'? 'active':'' " *ngIf="!isCustomLock&&isShowApproach&&showGoToSurveyBtn&&isOpenClass==0&&isShowQuestionnaire&& !isTencent">
      <component-approach [theme]="approachTheme" [isFirst]="isShowQuestionnaire" (onGoCourse)="goToPostSurvey()"></component-approach>
    </div>

    <div class="approachModuleWrap" [ngClass]="type === 'huatek'? 'active':'' " *ngIf="!isCustomLock&&isShowApproach&&showGoToSurveyBtn&&isOpenClass==0&&!isShowQuestionnaire&& !isTencent">
      <component-approach [theme]="approachTheme" [isFirst]="isShowQuestionnaire" (onGoCourse)="goToPostSurvey()"></component-approach>
    </div>

  </div>

</div>

<app-questionnaire [enter]="1" [learningPathMetaId]="learningPathMetaId" [isShowQuestionnaire]="isShowQuestionnaire && !type && !isTencent" (onExit)="closeQuestionnaire()"></app-questionnaire>



// WEBPACK FOOTER //
// ./src/app/case-practice-team-list/case-practice-team-list.component.html